import { NEIGHBORHOODS, Neighborhood } from '@/types/bar';

export type CategoryId = 'happy-hour' | 'trivia';

export interface CategoryLandingRoute {
  path: string;
  neighborhoodId: Neighborhood | null;
  categoryId: CategoryId;
}

const CATEGORY_IDS: CategoryId[] = ['happy-hour', 'trivia'];

export const CATEGORY_LANDING_ROUTES: CategoryLandingRoute[] = (() => {
  const routes: CategoryLandingRoute[] = [];
  for (const cat of CATEGORY_IDS) {
    routes.push({ path: `/chicago-${cat}`, neighborhoodId: null, categoryId: cat });
    for (const n of NEIGHBORHOODS) {
      routes.push({ path: `/${n.id}-${cat}`, neighborhoodId: n.id, categoryId: cat });
    }
  }
  return routes;
})();
